import React from 'react';
import { usePriceToast } from '../hooks/usePriceToast';

export const PricingProviderContent: React.FC = ({ children }) => {
    usePriceToast();
    return <>{children}</>;
};
